<template>
  <div>
    <el-table v-loading="loading" :data="noteList" @sort-change="handleSortChange">
      <el-table-column label="患者姓名" align="center" prop="userName" />
      <el-table-column label="员工id" align="center" prop="employeeUserId" />
      <el-table-column label="笔记内容" align="center" prop="noteContent" />
      <el-table-column label="记录时间" align="center" prop="happenDate" width="180" sortable="custom"  :sort-orders="['descending', 'ascending']">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.happenDate, '{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
<!--      <el-table-column label="创建时间" align="center" prop="createDate" width="180" sortable="custom" :sort-orders="['descending', 'ascending']">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ parseTime(scope.row.createDate, '{y}-{m}-{d}') }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>

    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"/>
  </div>
</template>

<script>


import { listUserNote } from "@/api/biz/UserNote";

export default {
  props: {
    user: {
      type: Object
    }
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      loading: true,
      // 总条数
      total: 0,
      // 用户体重记录表格数据
      noteList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 排序触发事件 */
    handleSortChange(column, prop, order) {
      this.queryParams.orderByColumn = column.prop;
      this.queryParams.isAsc = column.order;
      this.getList();
    },
    /** 查询用户体重记录列表 */
    getList() {
      this.queryParams.userId = this.user.id;
      this.loading = true;
      listUserNote(this.queryParams).then(response => {
        this.noteList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    close() {
      this.$tab.closePage();
    }
  }
};
</script>
